import type { ResourceMap } from 'app/resources/types';
import type { PurchasesList } from 'libs/offerSystem/OfferSystemHistory';
import type { StateProxy } from './offersTypes';
import { calculateSpendingBand } from '../iap/calculateSpendingBand';
import type { App } from '../App';

export class GameStateProxy implements StateProxy {
  constructor(
    private readonly app: App
  ) {}

  public getLevelNumber(): number {
    return this.app.stateController.getLevelNumber();
  }

  public getInventory(): ResourceMap {
    return this.app.resources.getInventory();
  }

  public getCurrentTime(): number {
    return Date.now();
  }

  public getUserCreateDate(): number {
    return this.app.stateController.getUserFirstLoginDate();
  }

  public getBand(history: PurchasesList): number {
    return calculateSpendingBand(history);
  }

  public isTier1(): boolean {
    return this.app.utils.geoLocator.isTier1();
  }

  public isInSeasonPassWithoutPremium(): boolean {
    const data = this.app.stateController.getData().seasonPass;
    if (!data) return false;
    return !data.premiumPurchased;
  }
}
